import tw from 'tailwind-styled-components'

const NotifyContainer = tw.div`
md:mx-12
mx-6
my-6
bg-white
boxShadow
rounded-lg
min-w-[380px]
relative
`
export const ButtonAction = tw.button`
text-sm
border-[1px]
rounded-lg
h-[38px]
inline-flex
items-center
hover:brightness-95
transition-all
active:scale-[.97]
`
export const ExportPDFButton = tw.button`
  flex
  items-center
  justify-center
  text-sm
  text-[#DF8D2C]
  bg-white
  border
  border-[#DF8D2C]
  p-2
  rounded-lg
  h-[38px]
  px-6
  hover:brightness-95
  transition-all
  active:scale-95
  w-auto
  whitespace-nowrap
`;

const NotifyMain = tw.form`
flex
flex-col
justify-center
`
const NotifyContent = tw.form`
grid
grid-cols-3
gap-2
w-full
mt-6
flex
flex-col
`
export {
    NotifyContainer,
    NotifyMain,
    NotifyContent,
}
